function of() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return function (start, sink) {
    if (start !== 0) return;
    var disposed = false;
    sink(0, function (type) {
      if (type !== 2) return;
      disposed = true;
      values.length = 0;
    });

    while (values.length !== 0) {
      sink(1, values.shift());
    }

    if (disposed) return;
    sink(2);
  };
}

export default of;



//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-of/dist/callbag-of.esm.js
// module id = 628
// module chunks = 0